export const INTERVALS = [
  {
    id: '0h45m',
    hours: 0,
    minutes: 45,
  },
  {
    id: '1h0m',
    hours: 1,
    minutes: 0,
  },
  {
    id: '1h30m',
    hours: 1,
    minutes: 30,
  },
  {
    id: '2h0m',
    hours: 2,
    minutes: 0,
  },
  {
    id: '2h30m',
    hours: 2,
    minutes: 30,
  },
  {
    id: '3h0m',
    hours: 3,
    minutes: 0,
  },
  {
    id: '3h30m',
    hours: 3,
    minutes: 30,
  },
  {
    id: '4h0m',
    hours: 4,
    minutes: 0,
  },
  {
    id: '4h30m',
    hours: 4,
    minutes: 30,
  },
  {
    id: '4h45m',
    hours: 4,
    minutes: 45,
  },
];
